export default __webpack_public_path__ + "static/lifinity-cdf7841fca251e0ae73e24cfde837b96.png";